<template>
	<v-dialog
		:value="visible"
		max-width="1200"
		aria-labelledby="chart-overlay-title"
		@input="$emit('close')"
	>
		<v-card>
			<v-card-title>
				<span id="chart-overlay-title">
					Total Data Subjects
				</span>
				<v-spacer />
				<v-btn
					icon
					aria-label="Close chart overlay"
					@click="$emit('close')"
				>
					<v-icon>
						mdi-close
					</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<div
					v-if="chartData && chartData.datasets"
					class="chart-container"
				>
					<LineChart
						:chart-data="chartData"
						:chart-options="chartOptions"
						:use-time-scale="true"
						time-unit="day"
						:height="400"
					/>
				</div>
				<div
					v-else
					class="chart-placeholder"
				>
					<p>
						No chart data available
					</p>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import LineChart from '../../../../../shared/components/chart/line-chart.vue'

export default {
	name: 'data-subject-chart-overlay',
	components: {
		LineChart
	},
	props: {
		visible: {
			type: Boolean,
			required: true
		},
		chartData: {
			type: Object,
			required: false,
			default: null,
			validator: value => {
				return value === null || (typeof value === 'object' && 'datasets' in value)
			}
		},
		chartOptions: {
			type: Object,
			required: true,
			validator: value => {
				return value !== null && typeof value === 'object'
			}
		}
	}
}
</script>

<style scoped>
.chart-container {
	width: 100%;
	min-height: 400px;
}

.chart-placeholder {
	height: 400px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #757575;
}
</style>
